
import api from "../axios-setup/axios";

/**
 * Get Organization Intent
 * @param {string} organizationId - Organization id
 * @returns {Promise<object>} result
 */
export const getOrganizationIntentById = async (organizationId) => {
  const response = await api.get(`/organizations/${organizationId}/intent`);

  return response.data;
};

/**
 * Get Organization API Endpoints (Intent source)
 * @param {string} organizationId - Organization id
 * @returns {Promise<Array>} result
 */
export const getOrganizationApiEndpointsByOrgId = async (organizationId) => {
  const response = await api.get(`/api-endpoints/org/${organizationId}`);
  return response.data;
};

/**
 * Update Organization API Endpoint by org id
 * @param {string} organizationId - Organization id
 * @param {object} payload - endpoint payload
 * @returns {Promise<object|Array>} result
 */
export const updateOrganizationApiEndpointByOrgId = async (
  organizationId,
  payload,
) => {
  try {
    const response = await api.put(`/api-endpoints/org/${organizationId}`, payload);
    return response.data;
  } catch (error) {
    // Fallback for APIs that accept POST for update/upsert.
    if (error?.response?.status === 405) {
      const fallbackResponse = await api.post(
        `/api-endpoints/org/${organizationId}`,
        payload,
      );
      return fallbackResponse.data;
    }
    throw error;
  }
};
